import axios from "axios";

const wadoRoot = () => {
  return `${window.config.dataSources[0].configuration['wadoRoot']}/studies`;
}

export class ImagemService {

  getImagensChave(STUDYUID_FKEY, SERIESUID_FKEY) {
    try {
      return axios.get(`${wadoRoot()}/${STUDYUID_FKEY}/${SERIESUID_FKEY}/getImagesKeyBySeriesLevel`);
    } catch (error) {
      console.log(error);
    }
  }

  putImageKey(VALUE, STUDYUID_FKEY, SERIESUID_FKEY, INSTANCEUID) {
    try {
      return axios.put(`${wadoRoot()}/${VALUE}/${STUDYUID_FKEY}/${SERIESUID_FKEY}/${INSTANCEUID}/putimagemimpressao`);
    }
    catch (error) {
      console.log(error);
    }
  }

  postImagemSecundaria(imagemSecundariaDTO) {
    try {
      var formdata = new FormData();
      formdata.append('InstanceUid', imagemSecundariaDTO.InstanceUid);
      formdata.append('Image', imagemSecundariaDTO.Image);
      return axios.post(`${wadoRoot()}/postGerarImagemSecundaria`, formdata);
    } catch (error) {
      console.log(error);
    }
  }

}
